import React from "react";
import logo from "assets/img/henry-schein-logo-png-transparent.png";
import sidelogo from "assets/img/HS_Thrive Unlocked__Lockup.png";
import unlock from "assets/img/HS_Thrive Unlocked__K.O.png";

const AlreadyEnrolled = () => {
  return (
    <>
      <style>{mobileCss}</style>

      <div style={styles.page}>
        {/* HEADER */}

        <div style={styles.fullHeader}>
          <div
            className="header-content"
            style={styles.headerContent}
          >
            <img
              src={logo}
              style={styles.logo}
              alt="logo"
            />

            <img
              src={sidelogo}
              style={styles.rightLogo}
              alt="sidelogo"
            />
          </div>
        </div>

        {/* CARD */}

        <div style={styles.card}>
          {/* CARD HEADER */}

          <div style={styles.cardHeader}>
            <img
              src={unlock}
              style={styles.unlockLogo}
              alt="unlock"
            />
          </div>

          <div style={styles.content}>
            {/* ICON */}

            <div style={styles.iconCircle}>
              i
            </div>

            {/* TITLE */}

            <h2 style={styles.title}>
              You’re All Set!
            </h2>

            <p style={styles.subtitle}>
           Your location is already enrolled in Thrive Unlocked.
            </p>

            {/* INFO BOX */}

            <div style={styles.infoBox}>
              <div style={styles.infoTitle}>
                No action is needed.
              </div>

              <p style={styles.infoText}>
              We see that your location is already enrolled. You can continue to enjoy your available Thrive Signature benefits and earn Growth Bonus Points based on your program participation.
              </p>
            </div>

            {/* DIVIDER */}

            <div style={styles.divider} />

            {/* FOOTER */}

            <div style={styles.footer}>
              <div style={styles.footerTitle}>
                Have Questions?
              </div>

              <div style={styles.footerText}>
                Contact Thrive Support—we’re
                here to help.
              </div>

              <div
                className="contact-box"
                style={styles.contact}
              >
                <span style={styles.link}>
                  1-833-473-4968
                </span>

                <span className="divider-line">
                  |
                </span>

                <span style={styles.link}>
                <a
                  href="mailto:Thrive.Support@henryschein.com"
                  style={{ color: "#1f5fbf", textDecoration: "none" }}
                >
                  Thrive.Support@henryschein.com
                </a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const styles = {
  page: {
  background: "#eef1f5",
  minHeight: "100vh",
  margin: 0,
  padding: "16px",
  fontFamily: "Arial, sans-serif",
  overflowX: "hidden",
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
},

  fullHeader: {
  width: "100%",
  maxWidth: "520px",
  background: "#fff",
  padding: "10px 16px",
  boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
  margin: "0 auto 20px auto",
  boxSizing: "border-box",
  borderRadius: "10px",
},

  headerContent: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "10px",
  },

  logo: {
    width: "120px",
    maxWidth: "45%",
    objectFit: "contain",
  },

  rightLogo: {
    width: "190px",
    maxWidth: "50%",
    objectFit: "contain",
  },

  /* CARD */

  card: {
    width: "100%",
    maxWidth: "520px",
    margin: "0 auto",
    background: "#fff",
    borderRadius: "14px",
    boxShadow:
      "0 6px 18px rgba(0,0,0,0.12)",
    overflow: "hidden",
  },

  cardHeader: {
    background: "#0A72BA",
    textAlign: "center",
    // padding: "10px",
  },

  unlockLogo: {
    width: "100%",
    maxWidth: "260px",
    objectFit: "contain",
  },

  content: {
    padding: "25px 20px",
  },

  /* ICON */

  iconCircle: {
    width: "70px",
    height: "70px",
    borderRadius: "50%",
    border: "2px solid #2563eb",
    color: "#2563eb",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "30px",
    margin: "0 auto 15px",
    fontWeight: "bold",
    background:"#f8fbff"
  },

  /* TEXT */

  title: {
    textAlign: "center",
    color: "#0E176D",
    marginBottom: "5px",
    fontSize: "30px",
  },

  subtitle: {
    textAlign: "center",
    fontSize: "14px",
    color: "#343F88",
    marginBottom: "20px",
    lineHeight: "22px",
  },

  /* INFO BOX */

  infoBox: {
    border: "1px solid #3b82f6",
    borderRadius: "10px",
    padding: "18px",
    background: "#f8fbff",
    textAlign: "center",
  },

  infoTitle: {
    color: "#1f5fbf",
    fontWeight: "bold",
    marginBottom: "8px",
    fontSize: "16px",
  },

  infoText: {
    fontSize: "13px",
    color: "#343F88",
    lineHeight: "22px",
  },

  divider: {
    height: "1px",
    background: "#e5e7eb",
    margin: "22px 0",
  },

  /* FOOTER */

  footer: {
    textAlign: "left",
  },

  footerTitle: {
    fontWeight: "bold",
    marginBottom: "5px",
    color: "#0E176D",
    fontSize: "15px",
  },

  footerText: {
    fontSize: "13px",
    marginBottom: "10px",
    color: "#343F88",
    lineHeight: "20px",
  },

  contact: {
    fontSize: "13px",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "8px",
  },

  link: {
    color: "#2563eb",
    cursor: "pointer",
    wordBreak: "break-word",
  },
};

/* MOBILE CSS */

const mobileCss = `
*{
  box-sizing:border-box;
}

body{
  margin:0;
  padding:0;
  overflow-x:hidden;
}

@media only screen and (max-width:768px){

  .header-content{
    display:flex !important;
    flex-direction:row !important;
    justify-content:space-between !important;
    align-items:center !important;
    flex-wrap:nowrap !important;
  }

  .contact-box{
    flex-direction:column !important;
    align-items:flex-start !important;
    gap:8px !important;
  }

  .divider-line{
    display:none;
  }
}

@media only screen and (max-width:480px){

  .header-content img:first-child{
    width:100px !important;
    max-width:42% !important;
  }

  .header-content img:last-child{
    width:150px !important;
    max-width:52% !important;
  }

  h2{
    font-size:24px !important;
  }
}
`;

export default AlreadyEnrolled;